
import Header from './components/Header';
import Hero from './components/Hero';
import RankingList from './components/RankingList';
import ComparisonTable from './components/ComparisonTable';
import TravelTips from './components/TravelTips';
import RelatedLinks from './components/RelatedLinks';
import Footer from './components/Footer';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import SEO from '../../../components/base/SEO';

export default function TravelPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "海外旅行におすすめのクレジットカード",
    "description": "海外旅行に最適なクレジットカードを厳選紹介。海外旅行傷害保険、空港ラウンジ、海外キャッシングなど、旅行に便利な機能を比較できます。",
    "about": {
      "@type": "Thing",
      "name": "海外旅行向けクレジットカード"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "ホーム",
          "item": "https://creditcard-start.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "利用シーン別",
          "item": "https://creditcard-start.com/use-cases"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "海外旅行",
          "item": "https://creditcard-start.com/use-cases/travel"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="海外旅行におすすめのクレジットカード【2026年最新】| クレカ比較ナビ"
        description="海外旅行に最適なクレジットカードを厳選紹介。海外旅行傷害保険、空港ラウンジ、海外キャッシングなど、旅行に便利な機能を徹底比較。年会費無料から充実保険のゴールドカードまで、あなたの旅行スタイルに合った1枚が見つかります。"
        keywords="海外旅行,クレジットカード,おすすめ,海外旅行保険,空港ラウンジ,海外キャッシング"
        canonicalUrl="https://creditcard-start.com/use-cases/travel"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '利用シーン別', path: '/use-cases' },
        { label: '海外旅行' }
      ]} />
      <Hero />
      <RankingList />
      <ComparisonTable />
      <TravelTips />
      <RelatedLinks />
      <Footer />
    </div>
  );
}
